<template>
  <section>
    <!-- Header -->
    <members-header
      :columnFilter="tableColumns"
      :weeks="weeks"
      @search="search"
    />
    <!-- Listing -->
    <div class="custom-wrapper">
      <div
        v-if="isPerformingAction"
        ref="actionOverlay"
        class="custom-overlay"
      ></div>
      <z-table
        ref="membersTable"
        :value="members"
        sortBy="LastName"
        orderBy="asc"
        :columns="tableColumns"
        :isSingleRowDetail="false"
        :isAllChecked="isAllChecked"
        class="table table-bordered table-striped"
        @sort="setOrder"
        @checkedAll="checkedAll"
        :loading="isLoading"
      >
        <template v-slot:tbody="props">
          <td class="z-column-60-center" style="vertical-align: middle">
            <input
              type="checkbox"
              :id="props.row.user_id"
              :checked="props.row.checked"
              @change="memberChecked"
              class="z-checkbox-small-centered"
            />
          </td>
          <td class="z-column-60-center">
            <star
              :level="props.row.starlevel"
              :id="props.row.user_id"
              @clicked="starClicked"
            />
          </td>
          <td class="z-column-80-center">
            <message-count
              :count="props.row.unread_messages"
              :id="props.row.user_id"
              @clicked="coachingClicked(props.row)"
            />
          </td>
          <td>
            <member-record
              :name="fullName(props.row)"
              :avatar="props.row.Avatar"
              :id="props.row.user_id"
              :isnew="props.row.isNew"
              @clicked="memberClicked"
            />
          </td>
          <td v-for="(column, idx) in columns" :key="idx" :class="column.class">
            <span v-if="column.code === 'NumActivitySessions'">{{
              props.row.SessionCount
            }}</span>
            <span v-else-if="column.code === 'TotalMinutes'">{{
              calcTotal(props.row.TotalTime)
            }}</span>
            <span v-else-if="column.code === 'PercentGoal'">{{
              calcPercent(props.row.Percent)
            }}</span>
            <span v-else-if="column.code === 'Calories'">{{
              props.row.Calories
            }}</span>
            <span v-else-if="column.code === 'MealsTracked'">{{
              props.row.MealsTracked
            }}</span>
            <span v-else-if="column.code === 'DaysLastSizeMeasurements'">
              {{ calcDaysSizeChange(props.row) }}
            </span>
            <span v-else-if="column.code === 'DaysLastWeightMeasurement'">
              {{ calcDaysWeightChange(props.row) }}
            </span>
            <weight-progress
              v-else-if="column.code === 'WeightChange'"
              :row="props.row"
            />
            <fat-progress
              v-else-if="column.code === 'BodyFatChange'"
              :row="props.row"
            />
            <food-progress
              v-else-if="column.code === 'ThumbsUp'"
              :row="props.row"
            />
            <span v-else-if="column.code === 'MealsProgress'">
              {{ formatFoodProgressPercent(props.row) }}
            </span>
            <span v-else-if="column.code === 'DaysLastPhotos'">
              {{ calcDaysPhoto(props.row) }}
            </span>
            <training-progress
              v-else-if="column.code === 'TrainingProgressGauge'"
              :progress="props.row.Percent"
              :width="140"
            />
            <zone-stats
              v-else-if="column.code === 'TrainingProgress'"
              :stats="prepStats(props.row)"
            />
            <challenge-progress
              v-else-if="column.code === 'ChallengeWeekScore'"
              :row="props.row"
            />
            <component-progress-total
              v-else-if="column.code.substring(0, 9) === 'Component'"
              :data="prepComponents(props.row, column.code)"
              :isRaw="true"
            />
            <!-- <component-progress
              v-else-if="column.code.substring(0, 9) === 'Component'"
              :data="prepComponents(props.row, column.code)"
              :isRaw="true"
            /> -->
            <span v-else-if="column.code === 'BodyFatChange2'">{{
              calcFatChange(props.row)
            }}</span>
            <span v-else-if="column.code === 'WeightChange2'">{{
              calcWeightChange(props.row)
            }}</span>
            <span v-else-if="column.code === 'Resources'">{{
              props.row.numResources
            }}</span>
            <span v-else-if="column.code === 'NutritionHabits'">{{
              props.row.numNutritionHabits
            }}</span>
            <span v-else></span>
          </td>

          <!-- <td>
            <training-progress :progress="props.row.Percent" />
          </td>
          <td class="z-column-140-right">{{ props.row.SessionCount }}</td>
          <td class="z-column-120-right">
            {{ calcTotal(props.row.TotalTime) }}
          </td>
          <td class="text-center">
            <zone-stats :stats="prepStats(props.row)" />
          </td>
          <td class="z-column-140-right">{{ props.row.Calories }}</td> -->
        </template>
        <template v-slot:empty> Nothing found! </template>
      </z-table>
    </div>
    <client-dialog :show="actionMember" @close="closeMemberDialog" />
    <coaching-dialog :show="actionCoaching" @close="closeCoachingDialog" />
  </section>
</template>
<script>
import { mapGetters, mapActions } from 'vuex'
import moment from 'moment'
import MembersHeader from './members-header'
import MemberRecord from '../elements/member'
import WeightProgress from '../elements/weight-progress'
import FatProgress from '../elements/bodyfat-progress'
import FoodProgress from '../elements/food-progress'
import TrainingProgress from '../elements/training-progress'
import MessageCount from '../elements/message-count'
import ZoneStats from '../elements/zone-stats'
import ChallengeProgress from '../elements/challenge-progress'
import ComponentProgress from '@/Components/Reporting/elements/component-progress'
import ComponentProgressTotal from '@/Components/Reporting/elements/component-progress-total'
import Star from '../elements/star'
import ZTable from '@/Components/ZElements/Table'
import ClientDialog from '../client/client-dialog'
import CoachingDialog from '@/Components/Coaching/coaching-dialog'
import globals from '../../../Plugins/globals'
export default {
  name: 'client-listing',
  components: {
    ZTable,
    MembersHeader,
    MemberRecord,
    WeightProgress,
    FatProgress,
    FoodProgress,
    TrainingProgress,
    MessageCount,
    ZoneStats,
    ChallengeProgress,
    ComponentProgress,
    ComponentProgressTotal,
    Star,
    ClientDialog,
    CoachingDialog,
  },
  props: {
    orgid: {
      type: Number,
      default: 0,
    },
  },
  data() {
    return {
      settings: [],
      actionMember: null,
      actionCoaching: null,
      isLoading: false,
      isPerformingAction: false,
    }
  },
  mounted() {
    let $this = this
    this.isLoading = false
    this.isPerformingAction = false
    let orgid = this.examineOrganization.id
    if (globals.isAdmin(this.profile)) {
      orgid = 1
    }
    this.getRoles({
      id: orgid,
    })
    this.getComponents({
      orgId: this.examineOrganization.id,
    })
    this.setChecked({
      action: 'reset',
      checked: false,
    })
    setTimeout(() => {
      $this.search()
    }, 250)
  },
  computed: {
    ...mapGetters('users', ['profile']),
    ...mapGetters('usercardio', [
      'summary',
      'members',
      'pager',
      'selectedView',
      'filter',
      'isAllChecked',
    ]),
    ...mapGetters('organizations', ['examineOrganization']),
    columns() {
      let _columns = []
      if (this.selectedView) {
        this.selectedView.columns.forEach((column) => {
          let _class = ''
          if (
            column.code === 'NumActivitySessions' ||
            column.code === 'TotalMinutes' ||
            column.code === 'PercentGoal'
          ) {
            _class = 'z-column-140-right'
          } else if (column.code === 'Calories') {
            _class = 'z-column-120-right'
          } else if (column.code === 'ChallengeWeekScore') {
            _class = 'z-column-160-right'
          } else if (column.code === 'MealsTracked') {
            _class = 'z-column-140-center'
          } else if (column.code === 'MealsProgress') {
            _class = 'z-column-120-right'
          } else if (column.code === 'DaysLastSizeMeasurements') {
            _class = 'text-center'
          } else if (column.code === 'DaysLastWeightMeasurement') {
            _class = 'text-center'
          } else if (column.code.substring(9) === 'Component') {
            _class = 'z-column-160-center'
          } else if (column.code === 'BodyFatChange2') {
            _class = 'z-column-100-right'
          } else if (column.code === 'WeightChange2') {
            _class = 'z-column-100-right'
          } else if (column.code === 'Resources') {
            _class = 'z-column-100-center'
          } else if (column.code === 'NutritionHabits') {
            _class = 'z-column-100-center'
          }
          _columns.push({
            code: column.code,
            class: _class,
            name: column.name,
          })
        })
      }
      return _columns
    },
    tableColumns() {
      let _columns = [
        {
          field: 'user_id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
          isFilter: false,
          isCheckAll: true,
          type: 'string',
        },
        {
          field: 'user_id',
          label: '',
          sortable: false,
          class: 'z-column-60-center',
          isFilter: false,
          type: 'numeric',
        },
        {
          field: 'unread_messages',
          label: '',
          sortable: true,
          class: 'z-column-80-center',
          isFilter: false,
          type: 'numeric',
        },
        {
          field: 'LastName',
          label: 'Your Clients',
          sortable: true,
          isFilter: false,
          type: 'string',
        },
      ]
      if (this.columns) {
        // x NumActivitySessions
        // x TotalMinutes
        // x PercentGoal
        // x Calories
        // x ThumbsUp
        // x MealsTracked
        // x MealsProgress
        // x DaysLastWeightMeasurement
        // x WeightChange
        // x BodyFatChange
        // x DaysLastSizeMeasurements
        // x DaysLastPhotos
        // x TrainingProgressGauge
        // x TrainingProgress
        // x ChallengeWeekScore
        // BodyFatChange2
        // WeightChange2
        // Resources
        // Nutrition Habits
        this.columns.forEach((column) => {
          switch (column.code) {
            case 'NumActivitySessions':
              _columns.push({
                field: 'SessionCount',
                label: '# Sessions',
                title: '# of activity sessions',
                sortable: true,
                class: 'z-column-140-right',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'TotalMinutes':
              _columns.push({
                field: 'TotalTime',
                label: 'Time (min)',
                title: 'total workout time (all zones)',
                sortable: true,
                class: 'z-column-140-right',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'PercentGoal':
              _columns.push({
                field: 'Percent',
                label: 'Percent %',
                title: 'percent within goal',
                sortable: true,
                class: 'z-column-140-right',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'Calories':
              _columns.push({
                field: 'Calories',
                label: 'Calories',
                title: 'estimated calories burned',
                sortable: true,
                class: 'z-column-120-right',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'ThumbsUp':
              _columns.push({
                field: 'ThumbsUp',
                label: 'Thumbs',
                sortable: false,
                class: 'text-center',
                style: 'position: relative; top: -4px;',
                html: `
                <div class="row">
                  <div class="col-md-12 text-center">Nutrition</div>
                </div> 
                <div class="row">
                  <div class="col-md-12 text-center" title="thumbs up/neutral/down">Progress</div>
                </div>`,
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'MealsTracked':
              _columns.push({
                field: 'MealsTracked',
                label: 'Meals',
                title: 'total meals tracked',
                sortable: true,
                class: 'z-column-120-center',
                isFilter: true,
                type: 'string',
              })
              break
            case 'MealsProgress':
              _columns.push({
                field: 'FoodProgressPercent',
                label: 'Up %',
                title: 'thumbs up / meals tracked',
                sortable: true,
                class: 'z-column-120-right',
                isFilter: false,
                type: 'string',
              })
              break
            case 'DaysLastSizeMeasurements':
              _columns.push({
                field: 'LastSizeMeasurements',
                label: 'Last Circumference',
                sortable: true,
                class: 'text-center',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'DaysLastWeightMeasurement':
              _columns.push({
                field: 'LastMeasurements',
                label: 'Last Weight',
                sortable: true,
                class: 'text-center',
                isFilter: true,
                type: 'numeric',
              })
              break
            case 'DaysLastPhotos':
              _columns.push({
                field: 'LastPhotos',
                label: 'Last Photo',
                sortable: false,
                class: 'text-center',
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'WeightChange':
              _columns.push({
                field: 'WeightChange',
                label: 'Weight Change',
                sortable: false,
                class: 'text-center',
                style: 'position: relative; top: -4px;',
                html: `
                <div class="row">
                  <div class="col-md-12 text-center">Body Weight (lbs)</div>
                </div> 
                <div class="row">
                  <div class="col-md-2 text-center" title="change between last two measurements">Change</div>
                  <div class="col-md-2 text-center">Start</div>
                  <div class="col-md-2 text-center" title="latest measurement">Latest</div>
                  <div class="col-md-2 text-center">Target</div>
                  <div class="col-md-4 text-center">Progress</div>
                </div>`,
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'BodyFatChange':
              _columns.push({
                field: 'BodyFatChange',
                label: 'Body Fat Change',
                sortable: false,
                class: 'text-center',
                style: 'position: relative; top: -4px;',
                html: `
                <div class="row">
                  <div class="col-md-12 text-center">Body Fat (%)</div>
                </div> 
                <div class="row">
                  <div class="col-md-2 text-center" title="change between last two measurements">Change</div>
                  <div class="col-md-2 text-center">Start</div>
                  <div class="col-md-2 text-center" title="latest measurement">Latest</div>
                  <div class="col-md-2 text-center">Target</div>
                  <div class="col-md-4 text-center">Progress</div>
                </div>`,
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'TrainingProgressGauge':
              _columns.push({
                field: 'TrainingProgress',
                label: 'Training Progress',
                sortable: false,
                class: 'text-center',
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'TrainingProgress':
              _columns.push({
                field: 'minutes',
                label: 'Training Progress',
                sortable: false,
                class: 'text-center',
                style: 'position: relative; top: -4px;',
                html: `
                <div class="row">
                  <div class="col-md-12 text-center">Training Progress (min)</div>
                </div> 
                <table style="width: 420px; margin: 0 auto">
                  <colgroup>
                    <col width="170px" />
                    <col width="110px" />
                    <col width="110px" />
                    <col width="110px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th><span title="active/goal w/percent">Active</span></th>
                      <th>Below Zone</th>
                      <th>In Zone</th>
                      <th>Above Zone</th>
                    </tr>
                  </thead>
                </table>`,
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'ChallengeWeekScore':
              _columns.push({
                field: 'ChallengeWeekScore',
                label: 'Challenge',
                sortable: false,
                class: 'text-center',
                style: 'position: relative; top: -4px;',
                html: `
                <div class="row">
                  <div class="col-md-12 text-center">Challenge</div>
                </div> 
                <table style="width: 600px; margin: 0 auto">
                  <colgroup>
                    <col width="240px" />
                    <col width="120px" />
                    <col width="240px" />
                  </colgroup>
                  <thead>
                    <tr>
                      <th>Name</th>
                      <th>Overall Score</th>
                      <th>Daily Progress</th>
                    </tr>
                  </thead>
                </table>`,
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'BodyFatChange2':
              _columns.push({
                field: 'BodyFatChange2',
                label: 'Body Fat Change',
                title: 'difference between last two measurements',
                sortable: false,
                class: 'z-column-120-right',
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'WeightChange2':
              _columns.push({
                field: 'WeightChange2',
                label: 'Weight Change',
                title: 'difference between last two measurements',
                sortable: false,
                class: 'z-column-120-right',
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'Resources':
              _columns.push({
                field: 'Resources',
                label: 'Resources',
                title: '# of Resources',
                sortable: false,
                class: 'z-column-120-center',
                isFilter: false,
                type: 'numeric',
              })
              break
            case 'NutritionHabits':
              _columns.push({
                field: 'NutritionHabits',
                label: this.summary
                  ? this.summary.habit
                    ? this.summary.habit.name
                    : 'Nutrition Habits'
                  : 'Nutrition Habits',
                sortable: false,
                class: 'z-column-120-center',
                isFilter: false,
                type: 'numeric',
              })
              break
            default:
              _columns.push({
                field: column.code,
                label: column.name,
                sortable:
                  column.code.substring(0, 9) === 'Component' ? true : false,
                class: 'z-column-160-center',
                isFilter: false,
              })
              break
          }
        })
      }
      console.log('Columns In View', _columns)
      return _columns
    },
    weeks() {
      let _data = []
      if (this.summary) {
        _data = this.summary.weeks
      }
      return _data
    },
  },
  methods: {
    ...mapActions('usercardio', [
      'getMembers',
      'setPager',
      'getMember',
      'setStarLevel',
      'setChecked',
      'resetWeek',
    ]),
    ...mapActions('coaching', [
      'getWallMessages',
      'resetWallMessages',
      'resetWallMessage',
      'setWorkingText',
    ]),
    ...mapActions('users', ['getRoles']),
    ...mapActions('global', ['setLoading']),
    ...mapActions('dashboardComponents', ['getComponents']),
    closeMemberDialog(isDirty) {
      this.actionMember = null
      if (this.summary) {
        if (this.summary.isChanged) {
          console.log('Week Changed, refreshing Coach list', this.summary)
          this.search()
        }
      }
      // if (isDirty) {
      //   this.search()
      // }
    },
    closeCoachingDialog(isDirty) {
      this.actionCoaching = null
      this.search()
    },
    async search() {
      try {
        this.setLoading(false)
        if (this.summary) {
          let date = moment(this.summary.weekCoach.value).format('YYYY-MM-DD')
          this.isLoading = true
          let columns = []
          this.columns.forEach((column) => {
            columns.push(column.code)
          })
          let filter = null
          let range = {
            min: null,
            max: null,
          }
          if (this.filter) {
            if (this.filter.filterAs) {
              let isReset = false
              if (this.filter.filterAs === -1) {
                filter = 'star'
                isReset = true
              } else if (this.filter.filterAs === -2) {
                filter = 'nonstar'
                isReset = true
              } else if (this.filter.filterAs === -4) {
                filter = 'new'
                isReset = true
              } else if (this.filter.filterAs === -3) {
                filter = null
              } else if (this.filter.filterAs !== '') {
                filter = this.filter.filterAs
                isReset = true
              }
              if (isReset) {
                this.setChecked({
                  action: 'reset',
                  checked: false,
                })
              }
            }
            if (this.filter.range) {
              range.limit = this.filter.range.limit
              if (parseInt(this.filter.range.min) >= 0) {
                range.min = parseInt(this.filter.range.min)
              }
              if (parseInt(this.filter.range.max) >= 0) {
                range.max = parseInt(this.filter.range.max)
              }
            }
          }
          let options = {
            orgid: this.orgid,
            page: this.pager.page,
            pageSize: this.pager.pageSize,
            sortBy: this.pager.sortBy ? this.pager.sortBy : 'LastName',
            orderBy: this.pager.orderBy,
            search: this.pager.search,
            dateStart: date,
            filter: filter,
            rangelimit: range.limit,
            rangemin: range.min,
            rangemax: range.max,
            columns: columns,
            forEmail: 0,
          }
          console.log('Refresh Members', options)
          await this.getMembers(options)
          this.isLoading = false
          window.app.$forceUpdate()
        }
      } catch (e) {
        console.log('Error', e)
      }
    },
    async setOrder(column, order) {
      this.setPager({
        name: 'sortBy',
        value: column.field,
      })
      this.setPager({
        name: 'orderBy',
        value: order,
      })
      await this.search()
    },
    checkedAll(data) {
      console.log('Check All Clicked')
      this.setChecked({
        action: 'all',
        checked: data,
      })
    },
    memberChecked(e) {
      this.$nextTick(() => {
        let data = {
          user_id: parseInt(e.srcElement.id),
          checked: e.srcElement.checked,
          FirstName: null,
          LastName: null,
        }
        let found = this.members.find(
          (x) => parseInt(x.user_id) === data.user_id
        )
        if (found) {
          data.FirstName = found.FirstName
          data.LastName = found.LastName
        }
        this.setChecked({
          action: 'member',
          checked: data,
        })
      })
    },
    fullName(row) {
      let name = ''
      if (row.LastName !== '') {
        name = row.LastName
      }
      if (name !== '') {
        name += `, ${row.FirstName}`
      } else {
        name = row.FirstName
      }
      if (row.NickName !== '') {
        name += ` (${row.NickName})`
      }
      return name
    },
    formatScore(data) {
      let result = null
      if (data) {
        result = `${globals.roundUp(data, 0)}%`
      }
      return result
    },
    async memberClicked(id) {
      this.setLoading(true)
      this.resetWeek(null)
      // TODO: remove subtraction for Production
      let date = moment(this.summary.week.value)
        // .subtract(4, 'years')
        .format('YYYY-MM-DD')
      // let date = moment(this.summary.week.value).format('YYYY-MM-DD')
      await this.getMember({
        id: id,
        date: date,
      })
      this.resetWallMessages()
      let data = {
        id: id,
        orgId: this.examineOrganization.id,
      }
      this.resetWallMessage(data)
      await this.getWallMessages(data)
      this.setWorkingText(null)
      console.log('Showing Member', date)
      this.actionMember = {
        id: id,
        title: 'Client Profile',
        date: date,
      }
      this.setLoading(false)
    },
    async coachingClicked(row) {
      // console.log('Coaching Clicked', row)
      // load up the coach wall for this member
      this.setLoading(true)
      this.resetWallMessages()
      this.setWorkingText(null)
      let data = {
        id: row.user_id,
        orgId: this.examineOrganization.id,
      }
      this.resetWallMessage(data)
      await this.getWallMessages(data)
      this.actionCoaching = row
      this.setLoading(false)
    },
    async starClicked(data) {
      await this.setStarLevel(data)
    },
    calcTotal(totalTime) {
      return (parseFloat(totalTime) / 60).toFixed(0)
    },
    calcPercent(percent) {
      return parseFloat(percent).toFixed(1)
    },
    calcFatChange(data) {
      let change = null
      if (data) {
        if (data.measurements) {
          if (data.measurements.length > 1) {
            let _prior = 0
            if (data.settargets) {
              _prior = parseFloat(data.settargets.startFat)
            } else if (data.targets !== null) {
              _prior = parseFloat(data.targets.startFat)
            }
            let _last = parseFloat(data.measurements[0].bodyFat)
            if (_prior !== 0 && _last !== 0) {
              change = `${globals.roundUp(_last - _prior, 1)}`
            }
            // let prior = parseFloat(data.measurements[1].bodyFat)
            // let last = parseFloat(data.measurements[0].bodyFat)
            // if (prior !== 0 && last !== 0) {
            //   change = `${globals.roundUp(last - prior, 1)}`
            // }
          }
        }
      }
      return change
    },
    calcWeightChange(data) {
      let change = null
      if (data) {
        if (data.measurements) {
          if (data.measurements.length > 1) {
            let _prior = 0
            if (data.settargets) {
              _prior = parseFloat(data.settargets.startWeight)
            } else if (data.targets) {
              _prior = parseFloat(data.targets.startWeight)
            }
            // let _prior = parseFloat(data.measurements[1].bodyWeight)
            let _last = parseFloat(data.measurements[0].bodyWeight)
            if (_prior !== 0 && _last !== 0) {
              change = `${globals.roundUp(_last - _prior, 1)}`
            }
          }
        }
        // if (data.measurements) {
        //   if (data.measurements.length > 1) {
        //     let prior = parseFloat(data.measurements[1].bodyWeight)
        //     let last = parseFloat(data.measurements[0].bodyWeight)
        //     if (prior !== 0 && last !== 0) {
        //       change = `${globals.roundUp(last - prior, 1)}`
        //     }
        //   }
        // }
      }
      return change
    },
    calcDaysWeightChange(data) {
      let result = null
      if (data.measurements !== undefined && data.measurements !== null) {
        if (data.measurements.length > 0) {
          let last = moment.utc(data.measurements[0].createdOn)
          let now = moment()
          result = `${now.diff(last, 'days')} days ago`
        }
      }
      return result
    },
    calcDaysSizeChange(data) {
      let result = null
      if (
        data.sizemeasurements !== undefined &&
        data.sizemeasurements !== null
      ) {
        if (data.sizemeasurements.length > 0) {
          let last = moment.utc(data.sizemeasurements[0].measurementDate)
          let now = moment()
          result = `${now.diff(last, 'days')} days ago`
        }
      }
      return result
    },
    calcTotalMeals(data) {
      let result = null
      if (data.foodTracking) {
        result = 0
        data.foodTracking.forEach((element) => {
          result += element.count
        })
      }
      return result
    },
    calcDaysPhoto(data) {
      let result = null
      if (data.lastPhoto !== undefined && data.lastPhoto !== null) {
        if (
          data.lastPhoto.taken !== undefined &&
          data.lastPhoto.taken !== null
        ) {
          let last = moment(data.lastPhoto.taken)
          let now = moment()
          result = `${now.diff(last, 'days')} days ago`
        }
      }
      return result
    },
    prepStats(row) {
      let data = {
        inAboveZoneTime: (parseFloat(row.InAboveZoneTime) / 60).toFixed(0),
        inAboveZone: (parseFloat(row.InAboveGoal) / 60).toFixed(0),
        percent: parseFloat(row.Percent).toFixed(1),
        belowZoneTime: (parseFloat(row.BelowZoneTime) / 60).toFixed(0),
        minutesBelowZone: parseFloat(row.MinutesBelowZone).toFixed(0),
        inZoneTime: (parseFloat(row.InZoneTime) / 60).toFixed(0),
        minutesInZone: parseFloat(row.MinutesInZone).toFixed(0),
        aboveZoneTime: (parseFloat(row.AboveZoneTime) / 60).toFixed(0),
        minutesAboveZone: parseFloat(row.MinutesAboveZone).toFixed(0),
      }
      return data
    },
    prepComponents(row, code) {
      let data = []
      let temp = null
      let id = code.substring(9)
      if (row.component1) {
        temp = JSON.parse(row.component1)
        if (parseInt(temp[0].id) === parseInt(id)) {
          data = temp
        }
      }
      if (row.component2) {
        temp = JSON.parse(row.component2)
        if (parseInt(temp[0].id) === parseInt(id)) {
          data = temp
        }
      }
      if (data.length > 0) {
        console.log('Component Progress', {
          row: row,
          code: code,
          id: id,
        })
      }
      return data
    },
    formatFoodProgressPercent(row) {
      let _data = null
      // console.log('Food Progress Percent', row)
      if (row.FoodProgressPercent) {
        let percent = parseFloat(row.FoodProgressPercent) * 100
        _data = percent.toFixed(1)
      }
      return _data
    },
  },
}
</script>
<style lang="scss" scoped>
.custom-wrapper {
  position: relative;
}
.custom-overlay {
  position: absolute;
  top: 0;
  left: 0;
}
</style>
